import styled from "styled-components";
import thick from "../../../../assets/icons/thick.svg"
import arrow from "../../../../assets/icons/arrow.svg"
import stack from "../../../../assets/icons/stack.svg"
import shelves from "../../../../assets/icons/shelves.svg"
import { Container } from "./comonStyles";
import { 
  Separator, 
  ServicesContianer, 
  ServicesHeader, 
  ServicesHeaderContainer, 
  ServicesList, 
  ServicesListItem, 
  ServicesListItemIcon, 
  ServicesListItemTextContainer, 
  ServicesListItemHeader, 
  ServicesListItemText,
  ServicesSubHeader
} from "./itemListStyles";
import { theme } from "../../../../helpers/theme";


const StoringTerms = () => {
  return ( 
    <>
      <StyledContainer>

        <ServicesContianer>
          <ServicesHeaderContainer>
            <ServicesHeader>Warunki temperaturowe</ServicesHeader>
            <ServicesSubHeader>Dostarczamy różnorodne warunki przechowywania, aby sprostać różnym potrzebom Twoich towarów.</ServicesSubHeader>
          </ServicesHeaderContainer> 
          <Separator />
          <ServicesList>
            <ServicesListItem>
              <ServicesListItemIcon src={thick}/>
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Nieogrzewane</ServicesListItemHeader>
                <ServicesListItemText>Nasze magazyny nieogrzewane są idealne do przechowywania produktów, które nie wymagają stałej kontroli temperatury, dzięki czemu można obniżyć koszty magazynowania. </ServicesListItemText>
              </ServicesListItemTextContainer>
            </ServicesListItem>
            <Separator />
            <ServicesListItem>
              <ServicesListItemIcon src={thick}/>
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Ogrzewane</ServicesListItemHeader>
                <ServicesListItemText>Dla produktów, które potrzebują utrzymania określonej temperatury, oferujemy ogrzewane magazyny, co zapewnia optymalne warunki przechowywania, szczególnie w okresie zimowym.</ServicesListItemText>
              </ServicesListItemTextContainer>
            </ServicesListItem>
            <Separator />
            <ServicesListItem>
              <ServicesListItemIcon src={thick}/>
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Chłodnia</ServicesListItemHeader>
                <ServicesListItemText>Nasze chłodnie są przeznaczone do produktów, które wymagają niskich temperatur, aby zachować świeżość i jakość. Zapewniamy kontrolę temperatury na najwyższym poziomie. </ServicesListItemText>
              </ServicesListItemTextContainer>
            </ServicesListItem>
            <Separator />
            <ServicesListItem>
              <ServicesListItemIcon src={thick}/>
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Kontrola temperatury</ServicesListItemHeader>
                <ServicesListItemText>W naszych magazynach z kontrolą temperatury możesz przechowywać produkty, których wymagania co do temperatury mogą się zmieniać. Nasz zaawansowany system monitorowania zapewnia stałą kontrolę i dostosowanie warunków do Twoich potrzeb. </ServicesListItemText>
              </ServicesListItemTextContainer>
            </ServicesListItem>
            <Separator />
          </ServicesList>
        </ServicesContianer>

        <ServicesContianer>
          <ServicesHeaderContainer>
          <ServicesHeader>Rodzaje składowania</ServicesHeader>
          <ServicesSubHeader>Różne produkty wymagają różnych podejść do składowania. Nasza oferta obejmuje różne rodzaje składowania, spełniające wszelkie normy bezpieczeństwa: </ServicesSubHeader>
          </ServicesHeaderContainer>
            <ServicesList>
              <ServicesListItemWhite>
              <ServicesListItemIcon src={arrow}/>
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Wysokie składowanie z Regałami</ServicesListItemHeader>
                <ServicesListItemText>Nasze magazyny są wyposażone w regały, które pozwalają na maksymalne wykorzystanie przestrzeni pionowej. To idealne rozwiązanie dla produktów o standardowych gabarytach p, które można składować na regałach. </ServicesListItemText>
              </ServicesListItemTextContainer>
              </ServicesListItemWhite>
              <ServicesListItemWhite>
              <ServicesListItemIcon src={stack}/>
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Składowanie płaskie</ServicesListItemHeader>
                <ServicesListItemText>Dla produktów o większych gabarytach, które nie wymagają składowania na dużych wysokościach, oferujemy płaskie składowanie na powierzchni magazynu. To zapewnia łatwy dostęp do towarów i wygodne zarządzanie nimi.</ServicesListItemText>
              </ServicesListItemTextContainer>
              </ServicesListItemWhite>
              <ServicesListItemWhite>
              <ServicesListItemIcon src={shelves}/>
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Półki</ServicesListItemHeader>
                <ServicesListItemText>Nasze magazyny są wyposażone w półki, które stanowią doskonałe rozwiązanie dla produktów o niewielkich rozmiarach, które wymagają precyzyjnego umiejscowienia. To pozwala na składowanie i organizację produktów zgodnie z Twoimi potrzebami.</ServicesListItemText>
              </ServicesListItemTextContainer>
              </ServicesListItemWhite>
            </ServicesList>
        </ServicesContianer>
      </StyledContainer>
    </>
      );
}

export default StoringTerms;

const StyledContainer = styled(Container)`
display: flex;
align-items: center;

@media ${theme.device.laptop} {
  align-items: stretch;
}

`


const ServicesListItemWhite = styled(ServicesListItem)`
  width: fit-content;
  // height: 128px;
  background-color: #FFFFFF;
  border-radius: 16px;
  padding-block: 30px;
  padding-inline: 25px;
`;